import React from 'react';

class Step extends React.Component {
  constructor() {
    super();
    this.isComplete = this.isComplete.bind(this);
  }

  isComplete(step) {
    if(this.props.step > step) {
      return 'complete';
    } else if(this.props.step === step) {
      return 'active';
    } else {
      return '';
    }
  }

  render() {
    const { data, skippable } = this.props;

    if(skippable) {
      return(
        <ol className="step">
          {
            data.map(
              (key, i) =>
              <li key={i}>
                <a href="#exam-details" className={`step__point tooltip ${this.isComplete(i + 1)}`} onClick={(e) => {this.props.setStep(e, i + 1)}}>
                  <div className="tooltip__body" role="tooltip">{data[i]}</div>
                </a>
              </li>
            )
          }
        </ol>
      );
    } else {
      return(
        <ol className="step">
          {
            data.map(
              (key, i) =>
              <li key={i}>
                <span className={`step__point tooltip ${this.isComplete(i + 1)}`}>
                  <div className="tooltip__body" role="tooltip">{data[i]}</div>
                </span>
              </li>
            )
          }
        </ol>
      );
    }
  }
}

export default Step;



// WEBPACK FOOTER //
// ./src/app/components/Common/Step.js